import React, { useState, useEffect, useRef } from 'react';
// import '../components/Chatbot.css'; // <--- REMOVE THIS LINE
import { supabase } from '../lib/supabase'; // ✅ make sure you have Supabase initialized
import * as FiIcons from 'react-icons/fi'; // For the close icon
import SafeIcon from '../common/SafeIcon'; // Assuming SafeIcon is in 'common'
 
const { FiX } = FiIcons; // Destructure FiX for the close button
 
// --- Configuration Data ---
const SERVICE_CONFIGS = {
  property_care: {
    serviceName: 'Property Care',
    description: 'We offer comprehensive oversight to keep your property in India safe, secure, and fully maintained.',
    options: [
      { text: 'Explore Property Services', action: 'display_info', payload: 'property_services_info' },
      { text: 'Submit Maintenance/Care Request', action: 'start_data_capture', payload: 'property_request' },
      { text: 'Check Request Status', action: 'run_status_checker', payload: null },
      { text: 'Return to Main Menu', action: 'main_menu', payload: null },
    ],
  },
  parental_care: {
    serviceName: 'Parental Care',
    description: "We provide dedicated, compassionate care and assistance for your parents back home, ensuring their well-being.",
    options: [
      { text: 'Explore Parental Care Support', action: 'display_info', payload: 'parental_plans_info' },
      { text: 'Request a Wellness Check-in', action: 'start_data_capture', payload: 'wellness_check_request' },
      { text: 'Emergency Assistance Contact', action: 'display_info', payload: 'emergency_info' },
      { text: 'Return to Main Menu', action: 'main_menu', payload: null },
    ],
  },
  travel_services: {
    serviceName: 'Travel Services',
    description: 'We handle your end-to-end travel arrangements for smooth and comfortable visits to India.',
    options: [
      { text: 'Explore Travel Services', action: 'display_info', payload: 'travel_services_info' },
      { text: 'Request Travel Arrangements', action: 'start_data_capture', payload: 'travel_request' },
      { text: 'Check Request Status', action: 'run_status_checker', payload: null },
      { text: 'Return to Main Menu', action: 'main_menu', payload: null },
    ],
  },
  celebrate: {
    serviceName: 'Celebrate',
    description: 'We help you coordinate celebrations, surprise gifts, and memorable experiences for your loved ones in India.',
    options: [
      { text: 'Explore Surprise & Event Packages', action: 'display_info', payload: 'celebrate_info' },
      { text: 'Plan a surprise or event', action: 'start_data_capture', payload: 'celebrate_request' },
      { text: 'Check Request Status', action: 'run_status_checker', payload: null },
      { text: 'Return to Main Menu', action: 'main_menu', payload: null },
    ],
  },
  financial_advisory: {
    serviceName: 'Financial Advisory',
    description: 'Our certified financial experts provide specialized NRE/NRO, taxation, and wealth advisory services.',
    options: [
      { text: 'Explore Financial Services', action: 'display_info', payload: 'financial_advisory_info' },
      { text: 'Schedule a Consultation', action: 'start_data_capture', payload: 'financial_request' },
      { text: 'Check Request Status', action: 'run_status_checker', payload: null },
      { text: 'Return to Main Menu', action: 'main_menu', payload: null },
    ],
  },
  custom_service: {
    serviceName: 'Custom Service',
    description: 'If you have a unique or custom requirement in India, we are here to support you.',
    options: [
      { text: 'Submit Custom Service Request', action: 'start_data_capture', payload: 'custom_request' },
      { text: 'Return to Main Menu', action: 'main_menu', payload: null },
    ],
  },
};
 
const DATA_CAPTURE_CONFIGS = {
  property_request: {
    formTitle: 'Property Care Request',
    fields: ['Your Full Name', 'Your Email Address', 'Property Address', 'Specific Maintenance Requirements'],
    successMessage: (data) => `Thank you, ${data['Your Full Name']}. Your property care request has been logged. Our property manager will email you details at ${data['Your Email Address']} within 24 business hours.`,
  },
  wellness_check_request: {
    formTitle: 'Wellness Check-in Request',
    fields: ['Your Full Name', 'Your Email Address', "Your Parents' Full Name", "Parents' Complete Address", 'Any specific medical/support needs'],
    successMessage: (data) => `Thank you, ${data['Your Full Name']}. A wellness check-in has been scheduled for ${data["Your Parents' Full Name"]}. A confirmation email has been dispatched to ${data['Your Email Address']}.`,
  },
  travel_request: {
    formTitle: 'Travel Arrangement Request',
    fields: ['Your Full Name', 'Your Email Address', 'Travel Dates & Destination', 'Accommodation or Car Rental Preferences'],
    successMessage: (data) => `Thank you, ${data['Your Full Name']}. Your travel request is registered. A travel desk specialist will contact you at ${data['Your Email Address']} shortly.`,
  },
  celebrate_request: {
    formTitle: 'Celebration or Surprise Event Request',
    fields: ['Your Full Name', 'Your Email Address', 'Recipient Name & Location', 'Surprise/Event Description & Date'],
    successMessage: (data) => `Fantastic! ${data['Your Full Name']}, we have received your celebration request. Our surprise event planner will reach out to you at ${data['Your Email Address']}.`,
  },
  financial_request: {
    formTitle: 'Financial Advisory Consultation',
    fields: ['Your Full Name', 'Your Email Address', 'Preferred Date/Time for Call', 'Primary Financial Area of Interest (Tax, NRE/NRO Accounts, Real Estate)'],
    successMessage: (data) => `Thank you, ${data['Your Full Name']}. Your advisory consultation request is confirmed. We will reach out to you at ${data['Your Email Address']} to share the invite link.`,
  },
  custom_request: {
    formTitle: 'Custom Service Request',
    fields: ['Your Full Name', 'Your Email Address', 'Description of the Custom Service needed'],
    successMessage: (data) => `Thank you, ${data['Your Full Name']}. Your custom service request has been logged. Our support team will review it and contact you at ${data['Your Email Address']} within 24 business hours.`,
  },
};
 
const STATIC_INFO = {
  property_services_info: 'Our comprehensive Property Care covers:\n• 24/7 Security Oversight & Inspections\n• Professional Rent Collection & Tenant Liaison\n• Scheduled Maintenance, Cleaning & Repairs\n• Utility Bill Management & Legal Liaison',
  parental_plans_info: 'Our Parental Care Services include:\n• Escorted Medical & Dental Check-ups\n• Regular Companionship & Wellness Check-ins\n• Home Delivery of Prescriptions & Groceries\n• Assistance with Banking, Errands & Utilities',
  travel_services_info: 'Our Travel Support covers:\n• Safe Airport Pickups & Premium Car Rentals\n• Custom Itinerary Planning & Tour Management\n• Premium & Verified Hotel Booking Assistance\n• Dedicated Travel Buddies for Elderly Relatives',
  celebrate_info: 'Celebrate special events from anywhere with:\n• Customized Surprises, Cakes & Gifts\n• Complete Decoration & Event Management\n• Professional Photography & Video Coverage\n• Dedicated Live Video Streaming for Virtual Guests',
  financial_advisory_info: 'Our NRI Advisory solutions include:\n• NRI Tax Compliance & Return Filing\n• Fund Repatriation Advice & Compliance\n• Managed Portfolios, Mutual Funds & Property Investments\n• NRE/NRO Account Setup & Support',
  emergency_info: 'For any urgent medical emergencies, please reach out to our dedicated 24/7 NRI Emergency Response Team at +91-XXXXX-XXXXX immediately.',
  status_checker_info: 'Our online tracking system is currently being optimized. To check the real-time status of any request, please use the "Talk to an Expert" option or check your dashboard.',
};
 
 
function NriBuddyChatbot({ onClose }) {
  const [messages, setMessages] = useState([]);
  const [isBotTyping, setIsBotTyping] = useState(false);
  const [conversationState, setConversationState] = useState('welcome');
  const [context, setContext] = useState({});
  const messagesEndRef = useRef(null);
  const isInitialLoad = useRef(true); // Ref to track initial load
 
  // --- Scroll to bottom ---
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isBotTyping]);
 
  // --- Welcome sequence (runs only once, checking if messages already exist) ---
  useEffect(() => {
    // Only run if it's the initial load and no messages are present
    if (isInitialLoad.current && messages.length === 0) {
      setTimeout(() => {
        addBotMessage("Welcome to NRI Local Buddy. I am your virtual assistant, dedicated to supporting you and your family back home in India.");
        setTimeout(() => {
          startUserIntro();
        }, 1000);
      }, 500);
      isInitialLoad.current = false; // Mark as no longer initial load after initiating
    }
  }, [messages.length]); // Dependency on messages.length to re-evaluate if messages change
 
  const addBotMessage = (text, options = []) => {
    setIsBotTyping(true);
    setTimeout(() => {
      const newMessage = {
        id: Date.now() + Math.random(),
        text,
        sender: 'bot',
        options,
      };
      setMessages((prev) => [...prev, newMessage]);
      setIsBotTyping(false);
    }, 800);
  };
 
  const addUserMessage = (text) => {
    const newMessage = { id: Date.now(), text, sender: 'user' };
    setMessages((prev) => [...prev, newMessage]);
  };
 
  // Helper to make onboarding prompts polite and professional
  const getIntroPrompt = (field) => {
    switch (field) {
      case 'Full Name': return "Could you please tell me your full name?";
      case 'Email': return "Thank you. What is your email address?";
      case 'Phone Number': return "Please provide your primary contact number (including country code).";
      case 'Is this your WhatsApp contact? (Yes/No)': return "Is this number active on WhatsApp? (Please reply Yes or No)";
      case 'Current Location': return "Lastly, what is your current city or country of residence?";
      default: return `Please enter your ${field}:`;
    }
  };
 
  // --- Step 1: Gather User Info ---
  const startUserIntro = () => {
    const newContext = {
      introStep: 0,
      userData: {},
      introFields: ['Full Name', 'Email', 'Phone Number', 'Is this your WhatsApp contact? (Yes/No)', 'Current Location'],
    };
    setConversationState('user_intro');
    setContext(newContext);
    addBotMessage("To begin, could you please tell me your full name?");
  };
 
  const continueUserIntro = async (input) => {
    const { introFields, introStep, userData } = context;
    const fieldName = introFields[introStep];
    const updatedUserData = { ...userData, [fieldName]: input };
    const nextStep = introStep + 1;
 
    if (nextStep < introFields.length) {
      setContext({ ...context, introStep: nextStep, userData: updatedUserData });
      addBotMessage(getIntroPrompt(introFields[nextStep]));
    } else {
      // ✅ Save to Supabase
      const saveUser = async () => {
        try {
          const { data, error } = await supabase
            .from('request_user')
            .insert([{
              name: updatedUserData['Full Name'],
              email: updatedUserData['Email'],
              phone: updatedUserData['Phone Number'],
              is_whatsapp: updatedUserData['Is this your WhatsApp contact? (Yes/No)'],
              location: updatedUserData['Current Location'],
              created_at: new Date(),
            }])
            .select('id')
            .single();
 
          if (error) {
            console.error("Supabase insert error:", error);
          } else if (data?.id) {
            setContext(prev => ({ ...prev, requestUserId: data.id }));
          }
        } catch (err) {
          console.error("Unexpected error:", err);
        }
      };
      saveUser();
 
      addBotMessage(`Thank you, ${updatedUserData['Full Name']}. Your details have been successfully registered. How may we assist you today?`);
      setTimeout(showMainMenu, 2000);
    }
  };
 
  // --- Main Menu ---
  const showMainMenu = (promptText = 'Please select the service category you would like to explore:') => {
    setConversationState('main_menu');
    addBotMessage(promptText, [
      { text: '🏡 Property Care', action: 'service_flow', payload: 'property_care' },
      { text: '❤️ Parental Care', action: 'service_flow', payload: 'parental_care' },
      { text: '✈️ Travel Services', action: 'service_flow', payload: 'travel_services' },
      { text: '🎉 Celebrate (Surprises)', action: 'service_flow', payload: 'celebrate' },
      { text: '💼 Financial Advisory', action: 'service_flow', payload: 'financial_advisory' },
      { text: '🛠️ Custom Service', action: 'service_flow', payload: 'custom_service' },
      { text: '🗣️ Talk to an Expert', action: 'human_handoff', payload: null },
    ]);
  };
 
  const startServiceFlow = (serviceKey) => {
    const config = SERVICE_CONFIGS[serviceKey];
    if (!config) return;
    const serviceName = config.serviceName;
    setConversationState('service_menu');
    setContext(prev => ({
      ...prev,
      activeServiceKey: serviceKey,
      activeServiceName: serviceName
    }));
    addBotMessage(`${config.description}\n\nHow would you like to proceed with ${serviceName}?`, config.options);
  };
 
  const startDataCapture = (formKey) => {
    const config = DATA_CAPTURE_CONFIGS[formKey];
    setContext(prev => ({
      ...prev,
      formKey,
      currentStep: 0,
      formData: {}
    }));
    setConversationState('data_capture');
    addBotMessage(`Let's log your ${config.formTitle}. First, could you please specify: ${config.fields[0]}?`);
  };
 
  const continueDataCapture = (userInput) => {
    const { formKey, currentStep, formData } = context;
    const config = DATA_CAPTURE_CONFIGS[formKey];
    const fieldName = config.fields[currentStep];
    const updatedFormData = { ...formData, [fieldName]: userInput };
    const nextStep = currentStep + 1;
 
    if (nextStep < config.fields.length) {
      setContext({ ...context, currentStep: nextStep, formData: updatedFormData });
      addBotMessage(`Thank you. Next, could you please provide: ${config.fields[nextStep]}?`);
    } else {
      // ✅ Save captured form data to Supabase status column
      const dataCaptureSummary = Object.entries(updatedFormData)
        .map(([key, val]) => `${key}: ${val}`)
        .join('\n');
     
      const saveFormData = async () => {
        if (context.requestUserId) {
          try {
            const { error } = await supabase
              .from('request_user')
              .update({ status: `${config.formTitle}:\n${dataCaptureSummary}` })
              .eq('id', context.requestUserId);
            if (error) console.error("Error updating form data status:", error);
          } catch (err) {
            console.error("Unexpected error:", err);
          }
        }
      };
      saveFormData();
 
      addBotMessage("Thank you, we will contact you shortly.");
      setTimeout(onClose, 2500);
    }
  };
 
  // --- User Input Handler ---
  const handleUserInput = (input, option = null) => {
    const userText = option ? option.text : input;
    if (!userText) return;
    addUserMessage(userText);
 
    if (option) {
      // Clear options from all previous messages after a selection (unselecting them)
      setMessages((prev) =>
        prev.map((msg) =>
          msg.options && msg.options.length > 0 ? { ...msg, options: [] } : msg
        )
      );
 
      switch (option.action) {
        case 'main_menu': showMainMenu(); break;
        case 'service_flow': startServiceFlow(option.payload); break;
        case 'display_info':
          addBotMessage(STATIC_INFO[option.payload]);
          setTimeout(() => {
            addBotMessage("Thank you, we will contact you shortly.");
            setTimeout(onClose, 2500);
          }, 3000);
          break;
        case 'start_data_capture': startDataCapture(option.payload); break;
        case 'run_status_checker':
          addBotMessage(STATIC_INFO.status_checker_info);
          setTimeout(() => {
            addBotMessage("Thank you, we will contact you shortly.");
            setTimeout(onClose, 2500);
          }, 3000);
          break;
        case 'human_handoff':
          addBotMessage("Connecting you to a human expert. They’ll reach out to your email shortly.");
          setTimeout(() => {
            addBotMessage("Thank you, we will contact you shortly.");
            setTimeout(onClose, 2500);
          }, 2500);
          break;
        default:
          addBotMessage("Sorry, I didn’t get that.");
      }
      return;
    }
 
    if (conversationState === 'user_intro') {
      continueUserIntro(userText);
      return;
    }
 
    if (conversationState === 'describe_service') {
      const serviceName = context.activeServiceName || 'Service';
      const descriptionString = `${serviceName}: ${userText}`;
     
      const saveDescription = async () => {
        if (context.requestUserId) {
          try {
            const { error } = await supabase
              .from('request_user')
              .update({ status: descriptionString })
              .eq('id', context.requestUserId);
            if (error) console.error("Error updating description:", error);
          } catch (err) {
            console.error("Unexpected error:", err);
          }
        }
      };
      saveDescription();
 
      addBotMessage("Thank you, we will contact you shortly.");
      setTimeout(onClose, 2500);
      return;
    }
 
    if (conversationState === 'service_menu') {
      const serviceName = context.activeServiceName || 'Service';
      const descriptionString = `${serviceName}: ${userText}`;
     
      const saveDescription = async () => {
        if (context.requestUserId) {
          try {
            const { error } = await supabase
              .from('request_user')
              .update({ status: descriptionString })
              .eq('id', context.requestUserId);
            if (error) console.error("Error updating description:", error);
          } catch (err) {
            console.error("Unexpected error:", err);
          }
        }
      };
      saveDescription();
 
      addBotMessage("Thank you, we will contact you shortly.");
      setTimeout(onClose, 2500);
      return;
    }
 
    if (conversationState === 'data_capture') {
      continueDataCapture(input);
    } else {
      addBotMessage("Please use the buttons to navigate, or select an option from the main menu.");
    }
  };
 
  const handleFormSubmit = (e) => {
    e.preventDefault();
    const userInput = e.target.elements.userInput.value.trim();
    if (userInput) {
      handleUserInput(userInput, null);
      e.target.reset();
    }
  };
 
  return (
    <div
      className="fixed inset-y-0 right-0 bg-opacity-50 flex items-center justify-center z-[205]" // Increased z-index
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-lg shadow-2xl flex flex-col w-11/12 md:w-96 h-[80vh] max-h-[600px] overflow-hidden"
        onClick={(e) => e.stopPropagation()} // Prevent click from closing modal
      >
        {/* Chat Header */}
        <div className="bg-blue-600 text-white p-4 flex items-center justify-between shadow-md">
          <span className="text-lg font-semibold">NRI Local Buddy Assistant</span>
          <button
            onClick={onClose}
            className="text-white hover:text-blue-200 transition-colors duration-200"
            aria-label="Close chat"
          >
            <FiX className="text-2xl" /> {/* Using FiX icon */}
          </button>
        </div>
 
        {/* Chat Messages */}
        <div className="flex-grow p-4 overflow-y-auto space-y-4 bg-gray-50">
          {messages.map((msg) => (
            <div
              key={msg.id}
              className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`}
            >
              <div
                className={`max-w-[75%] px-4 py-2 rounded-lg shadow ${
                  msg.sender === 'user'
                    ? 'bg-blue-500 text-white rounded-br-none'
                    : 'bg-gray-200 text-gray-800 rounded-bl-none'
                }`}
                style={{ whiteSpace: 'pre-wrap' }}
              >
                {msg.text}
                {msg.options && msg.sender === 'bot' && msg.options.length > 0 && (
                  <div className="mt-2 space-y-2">
                    {msg.options.map((opt, index) => (
                      <button
                        key={index}
                        className="block w-full text-left bg-blue-100 hover:bg-blue-200 text-blue-800 px-3 py-2 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onClick={() => handleUserInput(null, opt)}
                      >
                        {opt.text}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
          {isBotTyping && (
            <div className="flex justify-start">
              <div className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg rounded-bl-none shadow">
                <span className="animate-pulse">...</span>
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>
 
        {/* Chat Input Area */}
        <div className="p-4 bg-gray-100 border-t border-gray-200">
          <form onSubmit={handleFormSubmit} className="flex">
            <input
              type="text"
              name="userInput"
              placeholder="Type your answer here..."
              autoComplete="off"
              autoFocus
              className="flex-grow border border-gray-300 rounded-l-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-800"
              disabled={isBotTyping || (conversationState !== 'user_intro' && conversationState !== 'data_capture' && conversationState !== 'describe_service' && conversationState !== 'service_menu')}
            />
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 rounded-r-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Send
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
 
export default NriBuddyChatbot;
 